import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from '@/store/index';
import Home from '../views/Home.vue';
import Default from '../views/Default.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/:contract_id/:access_key',
    name: 'Home',
    component: Home,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Default',
    component: Default,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

/*
router.beforeEach((to, from, next) => {
  if (!store.state.user.isAuthenticated) {
    store.dispatch('checkIfLoggedIn').then((loggedIn) => {
      console.log(loggedIn);
      if (to.name !== 'Login' && !loggedIn) {
        next({ name: 'Login' });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});
*/

/*
router.beforeEach((to, from, next) => {
  const authUser = store.getters["auth/authUser"];
  const reqAuth = to.matched.some((record) => record.meta.requiresAuth);
  const loginQuery = { path: "/login", query: { redirect: to.fullPath } };

  if (reqAuth && !authUser) {
    store.dispatch("auth/getAuthUser").then(() => {
      if (!store.getters["auth/authUser"]) next(loginQuery);
      else next();
    });
  } else {
    next(); // make sure to always call next()!
  }
});
*/

export default router;
